import { Context, useContext } from "react";

export const useSafeContext = <T extends unknown>(
  context: Context<T>,
  name: string,
) => {
  const data = useContext(context);

  if (data === null) {
    throw new Error(`use${name} must be used within the ${name}Provider.`);
  } else {
    return data;
  }
};
